export enum SUPPORTED_LANGUAGES {
  af_ZA = 'af_ZA',
  ak_GH = 'ak_GH',
  an_ES = 'an_ES',
  bg_BG = 'bg_BG',
  cs_CZ = 'cs_CZ',
  de_DE = 'de_DE',
  en_US = 'en_US',
  es_ES = 'es_ES',
  fi_FI = 'fi_FI',
  fr_FR = 'fr_FR',
  hr_HR = 'hr_HR',
  hu_HU = 'hu_HU',
  it_IT = 'it_IT',
  ko_KR = 'ko_KR',
  nl_NL = 'nl_NL',
  pl_PL = 'pl_PL',
  pt_PT = 'pt_PT',
  ro_RO = 'ro_RO',
  sk_SK = 'sk_SK',
  th_TH = 'th_TH',
  tr_TR = 'tr_TR',
  zh_CN = 'zh_CN',
  ja_JP = 'ja_JP'
}

export const AVAILABLE_LANGUAGES = [
  SUPPORTED_LANGUAGES.af_ZA,
  SUPPORTED_LANGUAGES.ak_GH,
  SUPPORTED_LANGUAGES.an_ES,
  SUPPORTED_LANGUAGES.bg_BG,
  SUPPORTED_LANGUAGES.cs_CZ,
  SUPPORTED_LANGUAGES.de_DE,
  SUPPORTED_LANGUAGES.en_US,
  SUPPORTED_LANGUAGES.es_ES,
  SUPPORTED_LANGUAGES.fi_FI,
  SUPPORTED_LANGUAGES.fr_FR,
  SUPPORTED_LANGUAGES.hr_HR,
  SUPPORTED_LANGUAGES.hu_HU,
  SUPPORTED_LANGUAGES.it_IT,
  SUPPORTED_LANGUAGES.ko_KR,
  SUPPORTED_LANGUAGES.nl_NL,
  SUPPORTED_LANGUAGES.pl_PL,
  SUPPORTED_LANGUAGES.pt_PT,
  SUPPORTED_LANGUAGES.ro_RO,
  SUPPORTED_LANGUAGES.sk_SK,
  SUPPORTED_LANGUAGES.tr_TR,
  SUPPORTED_LANGUAGES.zh_CN,
  SUPPORTED_LANGUAGES.ja_JP
];
